import { ApiEndpoints } from '../../services/endpoints';
import {
    BASE_URL,
    CLOUDINARY_URL,
    CLOUDINARY_UPLOAD_PRESET,
    apiService,
} from '../../services/service';

import * as prodTypes from '../actionTypes';

export const create_store =
    (storeData, imageData = '') =>
    async (dispatch) => {
        try {
            dispatch({ type: prodTypes.CREATE_STORE });

            if (imageData) {
                const imgResponse = await uploadImage(imageData);
                storeData.logo_url = imgResponse.secure_url;
            }

            const response = await apiService.post({
                url: `${BASE_URL}${ApiEndpoints.CREATE_STORE}`,
                payload: storeData,
            });
            if (response.status === 'success') {
                dispatch({
                    type: prodTypes.CREATE_STORE_SUCCESS,
                    payload: response.data,
                });
            }
        } catch (error) {
            const message = error.response ? error.response.data.message : 'Something Went Wrong';
            dispatch({ type: prodTypes.CREATE_STORE_FAIL, payload: message });
        }
    };

export const get_ordered_products = () => async (dispatch) => {
    try {
        dispatch({ type: prodTypes.GET_ORDERED_PRODUCTS });
        const response = await apiService.get(`${BASE_URL}${ApiEndpoints.GET_ORDERED_PRODUCTS}`);
        if (response.status === 'success') {
            dispatch({
                type: prodTypes.GET_ORDERED_PRODUCTS_SUCCESS,
                payload: response.data,
            });
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';
        dispatch({ type: prodTypes.GET_ORDERED_PRODUCTS_FAIL, payload: message });
    }
};

export const get_store = () => async (dispatch) => {
    try {
        dispatch({ type: prodTypes.GET_STORE });
        const response = await apiService.get(`${BASE_URL}${ApiEndpoints.GET_STORE}`);
        if (response.status === 'success') {
            dispatch({
                type: prodTypes.GET_STORE_SUCCESS,
                payload: response.data,
            });
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';
        dispatch({ type: prodTypes.GET_STORE_FAIL, payload: message });
    }
};

export const add_to_store =
    (productData, imageData = '') =>
    async (dispatch) => {
        try {
            dispatch({ type: prodTypes.ADD_TO_STORE });

            if (imageData) {
                const imgResponse = await uploadImage(imageData);
                productData.image = imgResponse.secure_url;
            }

            const response = await apiService.post({
                url: `${BASE_URL}${ApiEndpoints.ADD_TO_STORE}`,
                payload: productData,
            });
            if (response.status === 'success') {
                dispatch({
                    type: prodTypes.ADD_TO_STORE_SUCCESS,
                    payload: response.data,
                });
            }
        } catch (error) {
            const message = error.response ? error.response.data.message : 'Something Went Wrong';
            dispatch({ type: prodTypes.ADD_TO_STORE_FAIL, payload: message });
        }
    };

export const remove_from_store = (data) => async (dispatch) => {
    try {
        dispatch({ type: prodTypes.REMOVE_FROM_STORE });
        const response = await apiService.put({
            url: `${BASE_URL}${ApiEndpoints.REMOVE_FROM_STORE}`,
            payload: data,
        });
        if (response.status === 'success') {
            await dispatch({
                type: prodTypes.REMOVE_FROM_STORE_SUCCESS,
                payload: response.data,
            });
            await dispatch(get_store());
        }
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Something Went Wrong';

        dispatch({ type: prodTypes.REMOVE_FROM_STORE_FAIL, payload: message });
    }
};

export const uploadImage = async (imageData) => {
    const formData = new FormData();
    formData.append('file', imageData);
    formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
    const newApiService = apiService.setConfig({});
    return await newApiService.post({
        url: `${CLOUDINARY_URL}`,
        payload: formData,
    });
};

export const update_variant_table = (data) => async (dispatch, getState) => {
    const tableData = getState().storeReducer.variantTableData;
    let result = { ...tableData, [data.name]: data.value };
    dispatch({ type: prodTypes.UPDATE_VARIANT_TABLE, payload: result });
};
